//
export default [
    {
        text: '#',
        value: 'id',
        width: '5%',
    },
    {
        text: 'nombre',
        value: 'name',
        width: '20%',
    },
    {
        text: 'nombre',
        value: 'address',
    },
    {
        text: 'creacion',
        value: 'created_at',
        align: 'right',
        width: '15%',
    },
]
